module.exports = __webpack_public_path__ + "img/Rectangle.51aa2af8.svg";